// 核心配置导出
export type {
  SynthiaConfig,
  PluginConfig,
  ConfigLoadOptions,
  ConfigValidationResult,
} from './config/config';
export { DEFAULT_CONFIG, defineConfig } from './config/config';

// 类型定义导出
export type { BuildStats, OptimizationResult, CacheInfo } from './types';

// 日志系统导出
export type { Logger, LoggerConfig, LogLevel } from './logger/logger';
export {
  createLogger,
  defaultLogger,
  LoggerFactory,
  loggerFactory,
  getLogger,
  setLogger,
  validateLogger,
  createSilentLogger,
  createConsoleLogger,
} from './logger/logger';

// 配置管理导出
export { ConfigLoader } from './config/config-loader';
export { ConfigValidator, quickValidate } from './config/config-validator';

// 插件系统导出
export * from './plugins/plugin';
export * from './plugins/plugin-registry';
export * from './plugins/plugin-manager';
export * from './plugins/plugin-loader';
